import { render, staticRenderFns } from "./WsAppWasajon.vue?vue&type=template&id=703fb4a6&"
import script from "./WsAppWasajon.vue?vue&type=script&lang=js&"
export * from "./WsAppWasajon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports